export default function _identity(x) {
  return x;
}


//////////////////
// WEBPACK FOOTER
// ./~/ramda/es/internal/_identity.js
// module id = Ao6W
// module chunks = 0